









import { Component, Prop, Vue } from "vue-property-decorator";
import { ArticleListItemModel } from "@/contentful/articleModel";

@Component
export default class BoxNews extends Vue {
  @Prop() private item!: ArticleListItemModel;
  get url(): string {
    return "/nyheter/" + this.item.sys.id;
  }

  get dateDisplay(): string {
    return new Date(this.item.sys.updatedAt).toLocaleDateString("sv-SE");
  }

  get body(): string {
    return this.item.fields.boxBody.replace(/(?:\r\n|\r|\n)/g, "<br>");
  }
}
